import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=dc1f220a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=dc1f220a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1f220a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc1f220a')) {
      api.createRecord('dc1f220a', component.options)
    } else {
      api.reload('dc1f220a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=dc1f220a&scoped=true&", function () {
      api.rerender('dc1f220a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2asVt7o4xF28k/JS/comp/GuestBox.vue"
export default component.exports